import React from "react";
import "../styles/Inicio.css";

const Inicio = ({ traducciones }) => {
  return (
    <div className="container-fluid inicio-container d-flex align-items-center text-start text-white">
      <div className="container-fluid">
        <h1 className="display-4">
          {traducciones.inicio
            ? traducciones.inicio.titulo
            : "Soluciones efectivas para energía segura."}
        </h1>
        <p className="lead mt-3">
          {traducciones.inicio
            ? traducciones.inicio.texto
            : "Asesoramos operaciones y proyectos en la prevención de accidentes mayores mediante una excelente gestión del riesgo, protegiendo así la vida, el negocio y el medio ambiente."}
        </p>
      </div>
    </div>
  );
};

export default Inicio;